import React from 'react'
import PropTypes from 'prop-types'
import CodeMirror from 'react-codemirror'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/display/placeholder'
import 'codemirror/addon/display/autorefresh'
import 'codemirror/lib/codemirror.css'

const QuickReplies = ({ input, meta }) => {
  let quickReplies
  try {
    quickReplies = JSON.parse(input.value).length
  } catch (e) {}

  const maxEntries = 20

  return (
    <div>
      <ul className='br-dm-attachments__requirements'>
        <li>Maximum {maxEntries} quick replies can be added</li>
        <li>Use JSON syntax</li>
        <li>
          <code>label</code> and <code>metadata</code> are required for all
          quick replies.
        </li>
        <li>
          Either all of the quick replies should have descriptions or none of
          them should have descriptions.
        </li>
      </ul>

      <CodeMirror
        className={meta.error && 'error'}
        options={{
          lineNumbers: true,
          placeholder:
            '[\n {\n  "label":"",\n  "description":"",\n  "metadata":""\n } \n]',
          autoRefresh: true,
          lineWrapping: true
        }}
        value={input.value}
        mode='javascript'
        onChange={input.onChange}
      />
      <div
        className={
          'br-input-footer' + (quickReplies > maxEntries ? ' error' : '')
        }
      >
        <a
          href='https://developer.twitter.com/en/docs/direct-messages/quick-replies/api-reference/options.html'
          target='_blank'
          rel='noopener noreferrer'
        >
          <span
            className='fa fa-question-circle'
            title='Twitter API reference '
          />
        </a>
        <div className='br-entries-number'>
          {typeof quickReplies === 'number' ? quickReplies : 'N/A'}
          <span> / {maxEntries}</span>
        </div>
      </div>

      {/* Invalid JSON error */}

      {meta.error &&
        meta.error.json && (
          <div className='br-error'>
            <strong>Invalid JSON</strong>
          </div>
        )}

      {/* The error-list-header and error-list only show if any of the errors (entryErrors) have been set */}

      {meta.error &&
        meta.error.length && (
          <div>
            <div className='br-error-list-heading'>Error(s):</div>

            <ul className='br-error-list'>
              {meta.error.map((error, index) => (
                <li key={index} className='br-error'>
                  {error}
                </li>
              ))}
            </ul>
          </div>
        )}
    </div>
  )
}
QuickReplies.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export default QuickReplies



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/dm-attachments/quick-replies.js